
function layout() {

  // //   theme color from localStorage and use it.
  var defaultColor = localStorage.getItem("userThemeBackColor");
  if (defaultColor && defaultColor != null) {
    $('body').attr('data-default-color', defaultColor);
  }
  else {
    localStorage.setItem('userThemeBackColor', 'light');
    $('body').attr('data-default-color', 'light');
  }
  // //   theme font from localStorage and use it.

/* both a mouse and touch input*/
  // @media (any-hover:hover) and (any-pointer:coarse) and (any-pointer:fine)
  const mouse= matchMedia('(hover:hover), (pointer:fine)').matches;
  const touch= matchMedia('(hover:none), (pointer:coarse)').matches;
  const both= matchMedia('(any-hover:hover), (any-pointer:coarse) , (any-pointer:fine)').matches;
  let defaultFontSize='small';
  var savedFontSize = localStorage.getItem("userThemeBackFont");
  if(!savedFontSize){
    if(mouse||both){
      defaultFontSize='small';
      // console.log('mousehdev');
        }
    if(touch){
      defaultFontSize='big';
      // console.log('touchdev');
        }
        localStorage.setItem('userThemeBackFont', defaultFontSize);
  }else{
    defaultFontSize=savedFontSize;
  }
  $('body').attr('data-default-font', defaultFontSize);


  // console.log('hello custom 2');

  // collapse menu
  // $('.icon-toggle-side-menu').on('click', function () {
  //   // $(".sidebar").toggleClass("fliph");
  //   $('#sidebar').toggleClass('collapse');
  //   $('.content').toggleClass('expand');
  //   $('.body-overlay').toggle(500);
  // });

  $('.body-overlay').on('click', function () {
    $('#sidebar').toggleClass('collapse');
    $('.content').toggleClass('expand');
    $('.body-overlay').hide();
  });

  // $('.menu-link').on('mouseleave , mouseenter', function () {
  //   console.log('test');
  //   $('.content').removeClass('expand');
  //   $('#sidebar').removeClass('collapse');
  // });

  // Active Link
  $('.menu-link').on('click', function () {
    $('.menu-link').removeClass('active-link');
    $(this).addClass('active-link');
  });

  // tooltip

  $(document).on('mouseenter', '.tip', function (event) {
    var height = $('.tip .app-tooltip .d-inline .static-tooltip').height();
    var off = $(this).offset().top;
    var offl = $(this).offset().left;
    if (offl > 1200) {
      $('.tip .app-tooltip .d-inline .static-tooltip').css('top', -height + 'px');
      $(this).addClass("left")
    }

    if (off >= 420 && ($(this).parent().index() >= 3)) {
      $('.tip .app-tooltip .d-inline .static-tooltip').css('top', -height + 'px');
      $(this).addClass("last")
    }

  });
  // tooltip


  // Dispaly none for menu on routing
  // $('.menu-link').on('click', function () {
  //   if (!($('.sidebar').hasClass('collapse'))) {
  //     $('#sidebar').removeClass('collapse');
  //     $('.content').removeClass('expand');
  //     $('.body-overlay').hide();
  //   }

  // });
  // hover search or menu icons in collapse mod labtop view
  // $(document).on('mouseenter', '.sidebar .menu-link, .menu-search', function (
  //   event
  // ) {
  //   if ($(window).width() >= 1025) {
  //     $('.content').removeClass('expand');
  //     $('#sidebar').removeClass('collapse');
  //   }
  // });

  // $(document)
  //   .on(
  //     '.sidebar .menu-link + .menu-submenu .has-sub .menu-link.has-sub-menu + .menu-submenu .has-sub .menu-link ',
  //     function (event) {
  //       console.log('Third Hovered');
  //     }
  //   )
  //   .on(
  //     'mouseleave',
  //     '.sidebar .menu-link + .menu-submenu .has-sub .menu-link.has-sub-menu + .menu-submenu .has-sub .menu-link ',
  //     function () {
  //       console.log('Third Moved');
  //     }
  //   );




  // first level hover

  $(document)
    .on(
      'mouseenter',
      '.sidebar .menu-item ',
      function (event) {
        // var menuitem = $(".sidebar .menu-item");
        // var top = $(".top").offset();
        // var botttom = $(".bottom").offset();
        // var submenu = $(this).find(">:first-child").next('.menu-submenu').find('.has-sub');
        // var offset = menuitem.offset();
        // var offsetsub = submenu.position();submenu.height() < 100
        // console.log('top' + top.top);
        // console.log('bottom' + botttom.top); offset.top < 40 &&
        if ($('.sidebar').hasClass('collapse') && $(window).width() >= 1025) {
          // console.log('first Hovered');



          if ($(this).hasClass('MenuID_533') || $(this).hasClass('MenuID_673')) {
            $(this).find(">:first-child").next('.menu-submenu').addClass('show');
            $(this).find(">:first-child").next('.menu-submenu').find('.has-sub').addClass('out-menu-up')

          }
          else {
            $(this).find(">:first-child").next('.menu-submenu').addClass('show');
            $(this).find(">:first-child").next('.menu-submenu').find('.has-sub').addClass('out-menu')
          }
        }
      }
    )
    .on(
      'mouseleave',
      '.sidebar .menu-item',
      function () {
        if ($('.sidebar').hasClass('collapse') && $(window).width() >= 1025) {

          // console.log('first Moved');
          $(this).find(">:first-child").next('.menu-submenu').removeClass('show');
          $(this).find(">:first-child").next('.menu-submenu').find('.has-sub').removeClass('out-menu')
        }
      }
    ).delay(3000);

  // second level hover
  $(document)
    .on(
      'mouseenter',
      '.sidebar .menu-item  .menu-submenu .has-sub  .menu-item',
      function (event) {
        event.stopPropagation();
        if ($('.sidebar').hasClass('collapse') && $(window).width() >= 1025) {
          if ($(this).hasClass('MenuID_668')) {
            $(this).find(">:first-child").next('.menu-submenu').addClass('show');
            $(this).find(">:first-child").next('.menu-submenu').find('.has-sub').addClass('out-menu-up-2')

          }
          else {
            $(this).find(">:first-child").next('.menu-submenu').addClass('show');
            $(this).find(">:first-child").next('.menu-submenu').find('.has-sub').addClass('out-menu-2')
          }

        }
      }
    )

    .on(
      'mouseleave',
      '.sidebar .menu-item  .menu-submenu .has-sub  .menu-item',
      function (event) {
        if ($('.sidebar').hasClass('collapse') && $(window).width() >= 1025) {

          // console.log('Second Moved');

          $(this).find(">:first-child").next('.menu-submenu').removeClass('show');
          $(this).find(">:first-child").next('.menu-submenu').find('.has-sub').removeClass('out-menu-2')
        }
      }
    ).delay(3000);








  $(document)
    .on(
      '.sidebar .menu-link + .menu-submenu .has-sub .menu-link.has-sub-menu + .menu-submenu .has-sub .menu-link ',
      function (event) {
        // console.log('Third Hovered');
      }
    )
    .on(
      'mouseleave',
      '.sidebar .menu-link + .menu-submenu .has-sub .menu-link.has-sub-menu + .menu-submenu .has-sub .menu-link ',
      function () {
        // console.log('Third Moved');
      }
    );
}
